// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"v2-z","dimensionLabel":"w2-z","styleChooserControlWrapper":"x2-z","styleChooserControl":"y2-z","disabled":"z2-z","giftCard":"A2-z","styleChooserText":"B2-z"};